import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
// import {LoginComponent} from '../login/login.component';
import {errorlist} from '../providers/errorlist';
import { User, SignupUser } from '../models/user';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

import {COUNTRY} from '../providers/country';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  modalReference: any;
  errorlist:any;
  public signinData: User = {};
  public signup: SignupUser = {first_name: null, last_name: null, email: null, area_id: null, country_code: '+1', phone: null, password: null, street_address: null, apt: null, cross_street: null, term: null};
  public isCollapsed = true;
  isLogedin:boolean;
  areaData:any = [];
  country : any;

  private clickSubscriber;

  constructor(private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) {
    this.country = COUNTRY;
   }

  ngOnInit() {
    this.signup = {
      first_name:"",
      last_name:"",
      email: "", 
      area_id:null,
      phone:"",
      password: "", 
      street_address:"",
      apt:"", 
      cross_street:"", 
      term:0,country_code: '+1'
    }
    //assign all errorlist in 
    this.errorlist = errorlist;

    //get area list for signup data
    this.auth.getarea().then((area) => {
      console.log(area.json())
      this.areaData = area.json().data;
      console.log(this.areaData)
    }).catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }

  lat:any= 0.00;
  lng:any = 0.00;
  location:string ="";
  userSettings = {
    "showCurrentLocation":false,
    "showSearchButton":false,
  }
  autoCompleteCallback1(selectedData:any) {
    //do any necessery stuff.
    ///console.log(selectedData);
    let geometry = selectedData.data.geometry;
    //console.log(geometry);
    if ((geometry) !== undefined) {  
      this.lat = geometry.location.lat;
      this.lng = geometry.location.lng;
    }
    this.location = selectedData.data.description; 
    //console.log('lat = '+this.lat,'lat = '+this.lng,'lat = '+this.location);
  }

  signupUser():void{
    this.signup['lat'] = this.lat;
      this.signup['lng'] = this.lng;
      this.signup['location'] = this.location;
      console.log(this.signup);
      if(this.location == ""){
        this.spinnerService.hide();
        this.auth.open("Location is required.");
      }else{
        this.spinnerService.show();
        this.auth.register(this.signup).then((register) =>{
          let response = register.json();
          if(response.replyCode == "error"){
            this.spinnerService.hide();
            this.auth.open(response.replyMsg);
          }else{
            this.signup = {};
            this.spinnerService.hide();
            this.auth.open(response.replyMsg);
            this.router.navigateByUrl('/');
          }
        }).catch((err) => {
          this.spinnerService.hide();
          console.log(err);
          this.auth.open(environment.error);
        });
      }
    }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/signup/signup.component.ts